import * as React from "react";
import { Divider, Typography, Modal, Box, Button, TextField, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import PropTypes from "prop-types";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  maxHeight: '90%', 
  overflowY: 'auto', 
  bgcolor: "background.paper",
  border: "1px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: "20px",
};

const lightColor = "rgba(255, 255, 255, 0.7)";

export default function NewModal(props) {
  const [open, setOpen] = React.useState(false);
  const handleClose = () => setOpen(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    const payload = {
      description: data.get("name"),
      value: data.get("valor"),
    };
    
    props.function(payload);
    return handleClose();
  };


  return (
    <div>
      <Button
        variant="outlined" color="inherit"
        sx={{ borderColor: lightColor }}
        startIcon={<AddIcon />}
        onClick={handleOpen}
        spacing={2}
      >
        Adicionar
      </Button>
      <Modal
        open={open} onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2" align="center">
            Adicionar Plano
          </Typography>
          <IconButton
            aria-label="fechar"
            size="large"
            onClick={handleClose}
            style={{ position: "absolute", top: "10px", right: "10px" }}
          >
            X
          </IconButton>
          <Divider />
          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }} align="center">

            <Box component="div" sx={{ mt: 1, mb: 2 }}>
              <TextField margin="normal" id="name" label="Nome" name="name" variant="standard"
                required fullWidth autoFocus />
            </Box>

            <Box component="div" sx={{ mt: 1, mb: 4 }}>
              <TextField margin="normal" id="valor" label="Valor" type="number" name="valor" variant="standard"
                required fullWidth />
            </Box>

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 2, mb: 2, bgcolor: "primary.main" }}
            >
              Adicionar
            </Button>

          </Box>
        </Box>
      </Modal>
    </div>
  );
}

NewModal.propTypes = {
  function: PropTypes.func.isRequired,
};
